"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBoxRight = exports.onCrossClick = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var Icon_1 = require("components/Icon");
require("./styles.scss");
var onCrossClick = function (props) { return function () {
    props.onResetSearchOptions();
    props.changeToCurrentFolder();
}; };
exports.onCrossClick = onCrossClick;
var enhance = (0, recompose_1.compose)((0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (nextProps) {
        if (this.props.searchFilterToggled !== nextProps.searchFilterToggled) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
exports.SearchBoxRight = enhance(function (props) {
    return (React.createElement("span", { className: 'file-list-search-box-right' },
        props.searchFilterToggled ? (React.createElement(Icon_1.Icon, { onClick: (0, exports.onCrossClick)(props), className: "fa-times" })) : null,
        React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('filelistSearch/tooltip/moreSearch')) },
            React.createElement(Icon_1.Icon, { onClick: props.onDropdownCadetClick, className: "fa-caret-down" }))));
});
